export default {
	"noscript.title": "JavaScript ist nicht aktiv!",
	"noscript.text":
		"Ohne JavaScript ist die Funktionalität dieses Angebots womöglich stark eingeschränkt. Bitte schalten Sie es in Ihrem Browser ein oder verwenden Sie einen anderen.",
} as const;
